
<template>
  <div>
    <div v-if="show_or_not">
      <el-container class="content-width" style="flex-direction: column">
        <div-unit
          unitTitle="Information of the protein uploaded "
          :customHTML="
            '(Mission ID = <span style=\'color:#ff9800\'>' +
            mission_id +
            '</span>)'
          "
        >
          <el-table
            :data="
              information.filter((v) => v.content != '.' && v.content != '')
            "
            stripe
            :show-header="false"
            style="width: 100%; font-size: 20px"
          >
            <el-table-column prop="title" width="240">
              <template slot-scope="scope">
                <b>{{ scope.row.title }}</b>
              </template>
            </el-table-column>
            <el-table-column prop="content">
              <template slot-scope="scope">
                <div v-if="scope.row.title == 'Structure'">
                  <div style="display: flex; justify-content: space-between">
                    <div
                      class="structure-title"
                      style="width: 420px; text-align: inherit"
                    >
                      Download structure
                      <a
                        :href="
                          '/files/structure-similarity/tmp/' +
                          mission_id +
                          '/' +
                          filename
                        "
                        target="_blank"
                        download=""
                        ><i class="fa fa-download" aria-hidden="true"></i
                      ></a>
                    </div>
                    <div
                      class="structure-title"
                      style="width: 420px; text-align: end"
                    >
                      Open in a new window
                      <a :href="ifram_url_new" target="_blank"
                        ><i aria-hidden="true" class="fa fa-hand-o-up"></i
                      ></a>
                    </div>
                  </div>
                  <iframe
                    :src="ifram_url"
                    frameborder="0"
                    style="height: 500px; width: 1000px"
                  ></iframe>
                </div>
                <div v-else>
                  <div v-html="scope.row.content"></div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div-unit>

        <div-unit
          v-show="show_percentage"
          unitTitle="The progress of your mission"
        >
          <div class="introduce-text">
            <p>
              <b
                >Mission ID:
                <span style="color: #ff9800">{{ mission_id }}</span></b
              >
            </p>
            <p>
              <b>You mission is running: </b>
            </p>
            <p class="name-wrapper">
              Aligning Structure:
              <span style="color: #ff9800; font-weight: bold">{{
                structure_id
              }}</span>
            </p>
            <p class="name-wrapper">
              Protein Name:
              <span style="color: #ff9800; font-weight: bold">{{
                protein_name
              }}</span>
            </p>

            <p class="name-wrapper">
              Protein Library:
              <span style="color: #ff9800; font-weight: bold">{{
                library
              }}</span>
            </p>
            <el-progress
              :text-inside="true"
              :stroke-width="26"
              :percentage="percentage"
            ></el-progress>
            <p>
              This mission is in progress, please wait until the mission is
              completed before checking the results.
            </p>
            <p style="font-weight: bold">
              Note: This page does not refresh automatically.
            </p>
          </div>
        </div-unit>

        <div-unit
          unitTitle="Result of alignment"
          :customHTML="
            '( <a href=\'/files/structure-similarity/tmp/' +
            mission_id +
            '/Results.csv\'>Download Result <i aria-hidden=\'true\' class=\'fa fa-download\'></i></a> )'
          "
        >
          <el-table
            :data="
              Alignresult.slice(
                (currentPage - 1) * pageSize,
                currentPage * pageSize
              )
            "
            stripe
            style="width: 100%; font-size: 20px"
          >
            <template slot="empty">
              <div>
                No Data (Result only display the protein scaffolds which are
                structurally similar to the input protein, TM-score ≥ 0.5,
                please select a proper sublibrary for analysis)
              </div>
            </template>
            <el-table-column
              v-if="domain_or_family != 'domain'"
              prop="Human_Protein_Name"
              label="Human Protein Name"
              sortable
            >
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>
                    <b>Human Protein Name:</b>
                    {{ scope.row.Human_Protein_Name }}
                  </p>
                  <p>
                    <b>Protein Structure ID:</b>
                    {{ scope.row.Human_Protein_ID }}
                  </p>
                  <p>
                    <b>Protein Library:</b>
                    {{ scope.row.Protein_Family }}
                  </p>
                  <p>
                    <b>UNIPROT ID:</b>
                    <a
                      :href="
                        'https://www.uniprot.org/uniprotkb/' + scope.row.UNIPROT
                      "
                      target="_blank"
                    >
                      {{ scope.row.UNIPROT }}</a
                    >
                  </p>
                  <p>
                    <b>Full Sequence Length:</b>
                    {{ scope.row.Human_Full_length_Protein_Length }}
                  </p>
                  <div slot="reference" class="name-wrapper">
                    {{ scope.row.Human_Protein_Name }}
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              prop="Domain_Name"
              label="Domain Name"
              sortable
            >
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>
                    <b>Domain Name:</b>
                    {{ scope.row.Domain_Name }}
                  </p>
                  <p>
                    <b>Domain ID:</b>
                    {{ scope.row.Domain_Id }}
                  </p>
                  <p>
                    <b>Domain Length:</b>
                    {{ scope.row.Domain_Length }}
                  </p>
                  <p>
                    <b>Human Protein Name:</b>
                    {{ scope.row.Human_Protein_Name }}
                  </p>
                  <div slot="reference" class="name-wrapper">
                    {{ scope.row.Domain_Name }}
                    [{{ scope.row.Human_Protein_Name }}]
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              v-if="domain_or_family != 'domain'"
              prop="Huamn_Aligned_Sequence_length"
              label="Acc. Length"
              align="center"
              sortable
              width="200"
            >
            </el-table-column>
            <el-table-column
              v-else
              prop="Domain_Length"
              label="Domain Length"
              align="center"
              sortable
              width="200"
            >
            </el-table-column>

            <el-table-column
              prop="Coverage"
              label="Coverage (%)"
              align="center"
              sortable
              width="180"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.Coverage | numFilter(4) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="TM_score"
              label="TM-score"
              align="center"
              sortable
              width="140"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.TM_score | numFilter(5) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="Maximum_expression"
              label="Expression"
              align="center"
              :filters="expression_level"
              :filter-method="filterTag"
              filter-placement="bottom-end"
              width="150"
            >
              <template slot-scope="scope">
                <el-tag
                  :class="'level-' + scope.row.Maximum_expression"
                  disable-transitions
                  >{{ scope.row.Maximum_expression }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              v-if="domain_or_family != 'domain'"
              prop=""
              label="Detail"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <div>
                  <a
                    :href="
                      '/detail?structure=' +
                      scope.row.Human_Protein_ID +
                      '&id=' +
                      mission_id
                    "
                    target="_blank"
                  >
                    <i class="fa fa-hand-o-up" aria-hidden="true"></i> Detail
                  </a>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              prop=""
              label="Detail"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <div>
                  <a
                    :href="
                      '/detail?structure=' +
                      scope.row.Domain_Id +
                      '&id=' +
                      mission_id
                    "
                    target="_blank"
                  >
                    <i class="fa fa-hand-o-up" aria-hidden="true"></i> Detail
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination
            align="center"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 50, 200, 500, 2000]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="Alignresult.length"
            style="font-size: 20px"
          >
          </el-pagination>
          <br />
        </div-unit>
      </el-container>
    </div>
    <div v-else class="content-width">
      <div-unit unitTitle="Waiting ...">
        <div class="introduce-text">
          <p>Waiting for alignment results ...</p>
          <br />
          <p>
            You can refresh the site manually, otherwise you need to check that
            the mission ID is valid
          </p>
        </div>
      </div-unit>
    </div>
  </div>
</template>



<script>
// import axios from "axios";
import api from "../../api/index";
import pathUrl from "../../api/path";
import DivUnit from "@/components/DivUnit.vue";
// import qs from "qs"
export default {
  data: () => ({
    show_or_not: false,
    show_error: false,
    ifram_url: "",
    ifram_url_new: "",
    filename: "",
    mission_id: "",

    show_percentage: true,
    percentage: 0,
    library: "waiting  ...",
    protein_name: "waiting  ...",
    structure_id: "waiting  ...",

    currentPage: 1, // 当前页码
    pageSize: 20, // 每页的数据条数
    expression_level: [
      { text: "High", value: "High" },
      { text: "Middle", value: "Middle" },
      { text: "Low", value: "Low" },
      { text: "Unknow", value: "Unknow" },
    ],
    information: [
      {
        title: "Job Title",
        content: "",
      },
      {
        title: "Sequence Length",
        content: "",
      },
      {
        title: "Sequence",
        content: "",
      },
      {
        title: "Structure",
        content: "",
      },
      {
        title: "Mission Describe",
        content: "",
      },
      {
        title: "SBP Name",
        content: "",
      },
      {
        title: "Synonyms",
        content: "",
      },
      {
        title: "Molecular Weight",
        content: "",
      },
      {
        title: "Thermal Denaturation TEMP",
        content: "",
      },
      {
        title: "Expression System",
        content: "",
      },
      {
        title: "Selection Method",
        content: "",
      },
      {
        title: "Highest Status",
        content: "",
      },
      {
        title: "Protein Scaffold",
        content: "",
      },
      {
        title: "Binding Target(s)",
        content: "",
      },
    ],
    domain_or_family: "family",
  }),
  components: {
    DivUnit,
  },
  methods: {
    onSubmit() {
      console.log("submit!");
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
    },
    filterTag(value, row) {
      console.log(this.Alignresult);
      return row.Maximum_expression === value;
    },
  },
  filters: {
    numFilter(value, point_num) {
      let realVal = parseFloat(value).toFixed(point_num);
      return realVal;
    },
  },
  beforeMount() {
    this.mission_id = this.$route.query.id;
  },
  mounted() {
    api.getAlignresult(this.mission_id).then((res) => {
      if (res.status == 200) {
        this.show_or_not = true;
      }
      this.domain_or_family = res.data.information.domain_or_family;
      this.Alignresult = res.data.results;

      this.information[0].content = res.data.information["Job Title"];
      try {
        var data1 = this.Alignresult[0];
        var Sequence = data1.Input_Protein_Sequence;
        this.information[1].content = data1.Input_Protein_Sequence_Length;
        var Sequence_list = [];
        for (let i = 0; i < Sequence.length; i += 60) {
          Sequence_list.push(Sequence.slice(i, i + 60));
        }
        this.information[2].content =
          "<span style='font-family: monospace;'>" +
          Sequence_list.join("<br>") +
          "</span>";
      } catch (e) {
        // 错误处理代码片段
      }

      this.information[3].content = "..";
      // console.log("this.ifram_url");
      this.filename = res.data.information.filename;
      this.ifram_url = `${pathUrl.localUrl}/files/show-structure/synbip/?id=${this.mission_id}&auto&500px&upload&${this.filename}`;
      this.ifram_url_new = `${pathUrl.localUrl}/files/show-structure/synbip/?id=${this.mission_id}&auto&auto&upload&${this.filename}`;
      console.log(this.ifram_url);
      // this.information[2].content =  `${pathUrl.localUrl}/files/show-structure/synbip/?id=${this.mission_id}&auto&500px&upload&${this.res.data.information["Job Title"]}`;
      this.information[4].content = res.data.information.desc;

      this.information[5].content =
        res.data.information.from_synbip["SBP_name"] +
        ` <a href="http://synbip.idrblab.net/data/sbp/details/${this.information[0].content}" target="_blank"><i aria-hidden="true" class="fa fa-external-link"></i></a>`;
      this.information[6].content =
        res.data.information.from_synbip["Synonyms"];
      this.information[7].content =
        res.data.information.from_synbip["Molecular Weight"];
      this.information[8].content =
        res.data.information.from_synbip["Thermal Denaturation TEMP"];
      this.information[9].content =
        res.data.information.from_synbip["Expression System"];
      this.information[10].content =
        res.data.information.from_synbip["Selection Method"];
      this.information[11].content =
        res.data.information.from_synbip["Highest Status"];
      this.information[12].content =
        res.data.information.from_synbip["Protein Scaffold"];
      this.information[13].content = res.data.information.from_synbip["Target"];
    });

    api.getProgress(this.mission_id).then((res) => {
      this.percentage = res.data.percentage;
      this.library = res.data.library;
      this.protein_name = res.data.protein_name;
      this.structure_id = res.data.structure_id;

      if (this.percentage == "100.0") {
        this.show_percentage = false;
      }
    });
  },
};
</script>

<style>
.el-table thead {
  color: black;
}

.el-popover {
  border: 1px solid #03a9f4;
  font-size: 20px;
  box-shadow: 0 2px 12px 0 rgb(207 206 206);
}

.introduce-text {
  margin-bottom: 30px;
  padding: 16px;
  background: #f1f1f1;
  border-radius: 10px;
  font-size: 20px;
  line-height: 1.8;
}

.el-pagination span,
.el-pager li,
.el-pagination__sizes .el-input .el-input__inner,
.el-input__inner,
.el-table-filter__bottom button,
.el-checkbox__label {
  font-size: 20px !important;
}

.el-pagination .el-select .el-input {
  width: 140px;
  margin: 0 5px;
}

.el-tag {
  height: auto;
  padding: 4px 10px;
  width: 100px;
}

.level-Unknow {
  color: #909399;
  background: #f4f4f5;
  border-color: #d3d4d6;
  font-size: 20px;
}
.level-Low {
  font-size: 20px;
}
.level-Middle {
  color: #e6a23c;
  background: #fdf6ec;
  border-color: #f5dab1;
  font-size: 20px;
}

.level-High {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
  font-size: 20px;
}
.name-wrapper {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.structure-title {
  text-align: center;
  color: #c55a11;
  /* font-style: italic; */
  /* font-weight: bold; */
  margin-bottom: 10px;
  margin-top: 10px;
}
.el-table__empty-text {
  line-height: 40px;
  width: 76%;
}
</style>